/** Version for MUI4 vs MUI5 passthrough components (AppBar, Paper, List, stepper primitives, etc.) */
export enum OsMuiCompatVersion {
  V1 = 1, // @material-ui/core (and lab where needed)
  V2 = 2, // @mui/material
}
